export const isEmailValid = (email) => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
};

export const isPasswordStrong = (password) => {
  const passwordRegex = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*\W).{8,}$/;
  return passwordRegex.test(password);
};

export const isNotEmpty = (value) => {
  return value.trim().length > 0;
};

export const convertTimestampToDate = (timestamp) => {
  const date = new Date(parseInt(timestamp, 10));
  const options = { month: 'short', day: 'numeric', year: 'numeric' };
  return date.toLocaleDateString('en-US', options).replace(',', '');
};

export const formatDateToReadable = (isoDate) => {
  const months = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec'
  ];

  const dateObj = new Date(isoDate);
  const day = dateObj.getDate();
  const month = months[dateObj.getMonth()];
  const year = dateObj.getFullYear();

  return `${month} ${day} ${year}`;
};

export const getDownloadableUrl = (url) => { 
  return url.includes('?') ? `${url}&download=1` : `${url}?download=1`;
};

export const formatTime = (seconds) => {
  const minutes = Math.floor(seconds / 60);
  const secs = Math.floor(seconds % 60);
  return `${minutes}:${secs < 10 ? '0' : ''}${secs}`;
};

export const getPlatformClassName = (baseClassName, platformClasses = {}) => {
  const userAgent = navigator.userAgent || navigator.vendor || window.opera;

  let platform = 'web';
  if (/android/i.test(userAgent)) {
    platform = 'android';
  } else if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
    platform = 'ios';
  }

  return `${baseClassName} ${platformClasses[platform] || ''}`.trim();
};

export const isMobileDevice = () => {
  return /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
};